import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="payment-method"
export default class extends Controller {
  static targets = [
    "creditCardTab",
    "cashCheckTab",
    "cashCheckPanel",
    "methodInput",
    "amountCollected",
    "cardDetails",
    "cardDetailsTitle",
    "cardSubmit",
    "cashCheckSubmit",
    "checkFields",
    "checkRadio",
  ];

  static values = { depositOnly: Boolean };

  connect() {
    this.select({ params: { method: "credit_card" } });
  }

  select(event) {
    const method = event.params.method;
    this.methodInputTarget.value = method;

    const notCreditCard = method === "cash_check";
    const skipCard = notCreditCard && this.depositOnlyValue;

    this.cashCheckPanelTarget.classList.toggle("hidden", !notCreditCard);
    this.amountCollectedTarget.required = notCreditCard;
    this.cardDetailsTarget.classList.toggle("hidden", skipCard);
    this.cardSubmitTarget.classList.toggle("hidden", skipCard);
    this.cashCheckSubmitTarget.classList.toggle("hidden", !skipCard);

    this.setActive(this.creditCardTabTarget, !notCreditCard);
    this.setActive(this.cashCheckTabTarget, notCreditCard);

    this.cardDetailsTitleTarget.textContent = notCreditCard
      ? "Credit Card is required for recurring subscription"
      : "Credit Card Details";
  }

  setActive(tab, active) {
    tab.classList.toggle("bg-dark-blue-700", active);
    tab.classList.toggle("text-white", active);
    tab.classList.toggle("text-gray-700", !active);
  }

  toggleCheckFields() {
    const checkedRadio = this.element.querySelector(
      'input[type="radio"]:checked',
    );

    this.checkFieldsTarget.classList.toggle(
      "hidden",
      checkedRadio?.value !== "check",
    );
  }
}
